/**
 * Returns Dynamic Generated CSS
 */

import generateCSS from '@Controls/generate-css';
import generateCSSUnit from '@Controls/generate-css-unit';

function styling(props) {
	const {
		layout,
		inactiveOtherItems,
		expandFirstItem,
		rowsGap,
		columnsGap,
		align,
		enableSeparator,
		boxBgColor,
		borderStyle,
		borderWidth,
		borderRadius,
		borderColor,
		questionTextColor,
		questionTextActiveColor,
		questionPaddingTypeDesktop,
		vquestionPaddingMobile,
		vquestionPaddingTablet,
		vquestionPaddingDesktop,
		hquestionPaddingMobile,
		hquestionPaddingTablet,
		hquestionPaddingDesktop,
		answerTextColor,
		answerPaddingTypeDesktop,
		vanswerPaddingMobile,
		vanswerPaddingTablet,
		vanswerPaddingDesktop,
		hanswerPaddingMobile,
		hanswerPaddingTablet,
		hanswerPaddingDesktop,
		iconColor,
		iconActiveColor,
		gapBtwIconQUestion,
		questionFontFamily,
		questionFontWeight,
		questionFontSizeType,
		questionFontSize,
		questionFontSizeMobile,
		questionFontSizeTablet,
		questionLineHeightType,
		questionLineHeight,
		questionLineHeightMobile,
		questionLineHeightTablet,
		answerFontFamily,
		answerFontWeight,
		answerFontSizeType,
		answerFontSize,
		answerFontSizeMobile,
		answerFontSizeTablet,
		answerLineHeightType,
		answerLineHeight,
		answerLineHeightMobile,
		answerLineHeightTablet,
		iconAlign,
		iconSize,
		iconSizeType,
		iconSizeMobile,
		iconSizeTablet,
		columns,
		tcolumns,
		mcolumns,
		questionLeftPaddingTablet,
		questionBottomPaddingTablet,
		questionLeftPaddingDesktop,
		questionBottomPaddingDesktop,
		questionLeftPaddingMobile,
		questionBottomPaddingMobile,
	} = props.attributes;

	let selectors = {};
	let tabletSelectors = {};
	let mobileSelectors = {};
	let iconColorSet = iconColor;
	let iconActiveColorSet = iconActiveColor;

	if ('undefined' === typeof iconColor || '' === iconColor) {
		iconColorSet = questionTextColor;
	}
	if ('undefined' === typeof iconActiveColor || '' === iconActiveColor) {
		iconActiveColorSet = questionTextActiveColor;
	}

	selectors = {
		' .wpsp-icon svg': {
			width: generateCSSUnit(iconSize, iconSizeType),
			height: generateCSSUnit(iconSize, iconSizeType),
			'font-size': generateCSSUnit(iconSize, iconSizeType),
			fill: iconColorSet,
		},
		' .wpsp-icon-active svg': {
			width: generateCSSUnit(iconSize, iconSizeType),
			height: generateCSSUnit(iconSize, iconSizeType),
			'font-size': generateCSSUnit(iconSize, iconSizeType),
			fill: iconActiveColorSet,
		},
		' .wpsp-faq-child__outer-wrap': {
			'margin-bottom': generateCSSUnit(rowsGap, 'px'),
		},
		'.wpsp-faq-layout-grid .block-editor-inner-blocks .block-editor-block-list__layout':
			{
				'grid-column-gap': generateCSSUnit(columnsGap, 'px'),
				'grid-row-gap': generateCSSUnit(rowsGap, 'px'),
			},
		' .wpsp-faq-item': {
			'background-color': boxBgColor,
			'border-style': borderStyle,
			'border-width': generateCSSUnit(borderWidth, 'px'),
			'border-radius': generateCSSUnit(borderRadius, 'px'),
			'border-color': borderColor,
		},
		' .wpsp-faq-item .wpsp-question': {
			color: questionTextColor,
		},
		' .wpsp-faq-item.wpsp-faq-item-active .wpsp-question': {
			color: questionTextActiveColor,
		},
		' .wpsp-faq-item:hover .wpsp-question': {
			color: questionTextActiveColor,
		},
		' .wpsp-faq-questions-button': {
			'padding-top': generateCSSUnit(
				vquestionPaddingDesktop,
				questionPaddingTypeDesktop
			),
			'padding-bottom': generateCSSUnit(
				questionBottomPaddingDesktop,
				questionPaddingTypeDesktop
			),
			'padding-right': generateCSSUnit(
				hquestionPaddingDesktop,
				questionPaddingTypeDesktop
			),
			'padding-left': generateCSSUnit(
				questionLeftPaddingDesktop,
				questionPaddingTypeDesktop
			),
		},
		' .wpsp-faq-content span': {
			'margin-top': generateCSSUnit(
				vanswerPaddingDesktop,
				answerPaddingTypeDesktop
			),
			'margin-bottom': generateCSSUnit(
				vanswerPaddingDesktop,
				answerPaddingTypeDesktop
			),
			'margin-right': generateCSSUnit(
				hanswerPaddingDesktop,
				answerPaddingTypeDesktop
			),
			'margin-left': generateCSSUnit(
				hanswerPaddingDesktop,
				answerPaddingTypeDesktop
			),
		},
		'.wpsp-faq-icon-row .wpsp-faq-item .wpsp-faq-icon-wrap': {
			'margin-right': generateCSSUnit(gapBtwIconQUestion, 'px'),
		},
		'.wpsp-faq-icon-row-reverse .wpsp-faq-item .wpsp-faq-icon-wrap': {
			'margin-left': generateCSSUnit(gapBtwIconQUestion, 'px'),
		},
		' .wpsp-faq-item:hover .wpsp-icon svg': {
			fill: iconActiveColorSet,
		},
		' .wpsp-faq-item .wpsp-faq-questions-button.wpsp-faq-questions': {
			'flex-direction': iconAlign,
		},
		' .wpsp-faq-questions-button .wpsp-question': {
			'font-size': generateCSSUnit(
				questionFontSize,
				questionFontSizeType
			),
			'line-height': generateCSSUnit(
				questionLineHeight,
				questionLineHeightType
			),
			'font-family': questionFontFamily,
			'font-weight': questionFontWeight,
		},
		' .wpsp-faq-item .wpsp-faq-content p': {
			'font-size': generateCSSUnit(answerFontSize, answerFontSizeType),
			'line-height': generateCSSUnit(
				answerLineHeight,
				answerLineHeightType
			),
			'font-family': answerFontFamily,
			'font-weight': answerFontWeight,
			color: answerTextColor,
		},
	};

	tabletSelectors = {
		' .wpsp-faq-questions-button': {
			'padding-top': generateCSSUnit(
				vquestionPaddingTablet,
				questionPaddingTypeDesktop
			),
			'padding-bottom': generateCSSUnit(
				questionBottomPaddingTablet,
				questionPaddingTypeDesktop
			),
			'padding-right': generateCSSUnit(
				hquestionPaddingTablet,
				questionPaddingTypeDesktop
			),
			'padding-left': generateCSSUnit(
				questionLeftPaddingTablet,
				questionPaddingTypeDesktop
			),
		},
		' .wpsp-faq-content span': {
			'margin-top': generateCSSUnit(
				vanswerPaddingTablet,
				answerPaddingTypeDesktop
			),
			'margin-bottom': generateCSSUnit(
				vanswerPaddingTablet,
				answerPaddingTypeDesktop
			),
			'margin-right': generateCSSUnit(
				hanswerPaddingTablet,
				answerPaddingTypeDesktop
			),
			'margin-left': generateCSSUnit(
				hanswerPaddingTablet,
				answerPaddingTypeDesktop
			),
		},
		' .wpsp-faq-questions-button .wpsp-question': {
			'font-size': generateCSSUnit(
				questionFontSizeTablet,
				questionFontSizeType
			),
			'line-height': generateCSSUnit(
				questionLineHeightTablet,
				questionLineHeightType
			),
		},
		' .wpsp-faq-item .wpsp-faq-content p': {
			'font-size': generateCSSUnit(
				answerFontSizeTablet,
				answerFontSizeType
			),
			'line-height': generateCSSUnit(
				answerLineHeightTablet,
				answerLineHeightType
			),
		},
		' .wpsp-icon svg': {
			width: generateCSSUnit(iconSizeTablet, iconSizeType),
			height: generateCSSUnit(iconSizeTablet, iconSizeType),
			'font-size': generateCSSUnit(iconSizeTablet, iconSizeType),
		},
		' .wpsp-icon-active svg': {
			width: generateCSSUnit(iconSizeTablet, iconSizeType),
			height: generateCSSUnit(iconSizeTablet, iconSizeType),
			'font-size': generateCSSUnit(iconSizeTablet, iconSizeType),
		},
	};

	mobileSelectors = {
		' .wpsp-faq-questions-button': {
			'padding-top': generateCSSUnit(
				vquestionPaddingMobile,
				questionPaddingTypeDesktop
			),
			'padding-bottom': generateCSSUnit(
				questionBottomPaddingMobile,
				questionPaddingTypeDesktop
			),
			'padding-right': generateCSSUnit(
				hquestionPaddingMobile,
				questionPaddingTypeDesktop
			),
			'padding-left': generateCSSUnit(
				questionLeftPaddingMobile,
				questionPaddingTypeDesktop
			),
		},
		' .wpsp-faq-content span': {
			'margin-top': generateCSSUnit(
				vanswerPaddingMobile,
				answerPaddingTypeDesktop
			),
			'margin-bottom': generateCSSUnit(
				vanswerPaddingMobile,
				answerPaddingTypeDesktop
			),
			'margin-right': generateCSSUnit(
				hanswerPaddingMobile,
				answerPaddingTypeDesktop
			),
			'margin-left': generateCSSUnit(
				hanswerPaddingMobile,
				answerPaddingTypeDesktop
			),
		},
		' .wpsp-faq-questions-button .wpsp-question': {
			'font-size': generateCSSUnit(
				questionFontSizeMobile,
				questionFontSizeType
			),
			'line-height': generateCSSUnit(
				questionLineHeightMobile,
				questionLineHeightType
			),
		},
		' .wpsp-faq-item .wpsp-faq-content p': {
			'font-size': generateCSSUnit(
				answerFontSizeMobile,
				answerFontSizeType
			),
			'line-height': generateCSSUnit(
				answerLineHeightMobile,
				answerLineHeightType
			),
		},
		' .wpsp-icon svg': {
			width: generateCSSUnit(iconSizeMobile, iconSizeType),
			height: generateCSSUnit(iconSizeMobile, iconSizeType),
			'font-size': generateCSSUnit(iconSizeMobile, iconSizeType),
		},
		' .wpsp-icon-active svg': {
			width: generateCSSUnit(iconSizeMobile, iconSizeType),
			height: generateCSSUnit(iconSizeMobile, iconSizeType),
			'font-size': generateCSSUnit(iconSizeMobile, iconSizeType),
		},
	};

	if ('accordion' === layout && true === inactiveOtherItems) {
		selectors[
			' .block-editor-block-list__layout .wpsp-faq-child__outer-wrap .wpsp-faq-content '
		] = {
			display: 'none',
		};
	}
	if ('accordion' === layout && false === inactiveOtherItems) {
		/* eslint-disable */
		(selectors[
			' .block-editor-inner-blocks .wpsp-faq-child__outer-wrap .wpsp-faq-item .wpsp-faq-questions-button .wpsp-icon-active'
		] = {
			display: 'inline-block',
		}),
			(selectors[
				' .block-editor-inner-blocks .wpsp-faq-child__outer-wrap .wpsp-faq-item .wpsp-faq-questions-button .wpsp-icon'
			] = {
				display: 'none',
			});
	}
	if ('accordion' === layout && true === expandFirstItem) {
		selectors[
			' .block-editor-block-list__layout > div:first-child > .wpsp-faq-child__outer-wrap .wpsp-faq-content '
		] = {
			display: 'block',
		};
		(selectors[
			' .block-editor-block-list__layout > div:first-child > .wpsp-faq-child__outer-wrap .wpsp-faq-item .wpsp-faq-questions-button .wpsp-icon-active '
		] = {
			display: 'inline-block',
		}),
			(selectors[
				' .block-editor-block-list__layout > div:first-child > .wpsp-faq-child__outer-wrap .wpsp-faq-item .wpsp-faq-questions-button .wpsp-icon '
			] = {
				display: 'none',
			});
		/* eslint-enable */
	}
	if (true === enableSeparator) {
		selectors[
			'.wpsp-faq__outer-wrap .wpsp-faq-child__outer-wrap .wpsp-faq-content '
		] = {
			'border-style': 'solid',
			'border-top-color': borderColor,
			'border-top-width': generateCSSUnit(borderWidth, 'px'),
		};
	}
	if ('grid' === layout) {
		selectors[
			' .block-editor-block-list__layout .wpsp-faq-child__outer-wrap '
		] = {
			'text-align': align,
		};
		selectors[
			'.wpsp-faq-layout-grid .block-editor-inner-blocks > .block-editor-block-list__layout '
		] = {
			'grid-template-columns': 'repeat(' + columns + ', 1fr)',
		};
		tabletSelectors[
			'.wpsp-faq-layout-grid .block-editor-inner-blocks > .block-editor-block-list__layout '
		] = {
			'grid-template-columns': 'repeat(' + tcolumns + ', 1fr)',
		};
		mobileSelectors[
			'.wpsp-faq-layout-grid .block-editor-inner-blocks > .block-editor-block-list__layout '
		] = {
			'grid-template-columns': 'repeat(' + mcolumns + ', 1fr)',
		};
	}

	let stylingCss = '';
	const id = `.wpsp-block-${props.clientId.substr(0, 8)}`;

	stylingCss = generateCSS(selectors, id);

	stylingCss += generateCSS(tabletSelectors, id, true, 'tablet');

	stylingCss += generateCSS(mobileSelectors, id, true, 'mobile');

	return stylingCss;
}

export default styling;
